/**
 * MultiRW Middleware
 *
 * @since: 2018-07-03
 * @author: mk.ko
 */

export default function ({isHMR, app, store, route}) {
  if (store.state.common.navigation.menu) {
    store.dispatch('common/multirw/setMenuInfo', route.path)
  }
}
